import FormSchemaBuilder from "./FormSchemaBuilder.vue";
import FormSchemaInputsVue from "./FormSchemaInputs.vue";

export default {
  install(Vue) {
    Vue.component("form-schema-inputs", FormSchemaInputsVue);
    Vue.component("fp-form-schema-builder", FormSchemaBuilder);
  },
};
